// DEPRECATED
export const GROUP_FILTER_SET = 'reports/GROUP_FILTER_SET'
export const GROUP_FILTER_UPDATE = 'reports/GROUP_FILTER_UPDATE'
export const GROUP_FILTER_DEFAULT = 'reports/GROUP_FILTER_DEFAULT'

export const GROUP_SPECIAL_FILTER_SET = 'reports/GROUP_SPECIAL_FILTER_SET'
export const GROUP_SPECIAL_FILTER_UPDATE = 'reports/GROUP_SPECIAL_FILTER_UPDATE'
export const GROUP_SPECIAL_FILTER_DEFAULT = 'reports/GROUP_SPECIAL_FILTER_DEFAULT'

export const BY_GROUPS_AND_TYPES = 'by_groups_and_types' as const
export const BY_USERS = 'by_users' as const

export const BY_STUDENTS = 'by_students' as const
export const BY_CLASSES = 'by_klasses' as const
export const BY_CLASSES_AND_ORDERS = 'by_klasses_and_orders' as const
export const BY_ALLOWANCES = 'by_allowances' as const
export const NO_GROUP = 'no_group' as const

export const BY_PURCHASES = 'by_purchases' as const
export const BY_ITEMS_AND_COMPLEXES = 'by_items_and_complexes' as const
export const BY_GROUP_COMPLEXES = 'by_group_complexes' as const
export const BY_ALLOWANCES_AND_FOOD_MODES = 'by_allowances_and_food_modes' as const

export const lang = {
  [BY_GROUPS_AND_TYPES]: 'типам пользователя и классам',
  [BY_USERS]: 'пользователям',

  [BY_STUDENTS]: 'пользователям и справкам',
  [BY_CLASSES]: 'классам',
  [BY_CLASSES_AND_ORDERS]: 'классам и справкам',
  [BY_ALLOWANCES]: 'категориям льгот',
  [NO_GROUP]: 'без группировки',
  [BY_ALLOWANCES_AND_FOOD_MODES]: 'категориям льгот и режимам питания',

  // BY_GROUPS_AND_TYPES
  [BY_PURCHASES]: 'продажам',
  [BY_ITEMS_AND_COMPLEXES]: 'продукции и комплектам',
  [BY_GROUP_COMPLEXES]: 'комплектам (групповой талон)',
}

export const getTitle = (key: string): string => {
  return lang[key] || '???'
}

export const groupsByReport = {
  balances: [
    BY_GROUPS_AND_TYPES,
    BY_USERS,
  ],
  subsidies_detailed: [
    NO_GROUP,
    BY_ALLOWANCES,
    BY_ALLOWANCES_AND_FOOD_MODES,
    BY_STUDENTS,
    BY_CLASSES,
    BY_CLASSES_AND_ORDERS,
  ],
  subsidies_detailed_multiple_orgs: [
    NO_GROUP,
    BY_ALLOWANCES,
    BY_ALLOWANCES_AND_FOOD_MODES,
  ],
  purchases: [
    BY_GROUPS_AND_TYPES,
    BY_PURCHASES,
    BY_ITEMS_AND_COMPLEXES,
    BY_GROUP_COMPLEXES,
  ],
}
